/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  min_length: Yup.number()
    .min(
      8,
      i18n.t('MIN_LENGTH_KEY', {
        value: 8,
      })
    )
    .max(
      32767,
      i18n.t('MAX_LENGTH_KEY', {
        value: 32767,
      })
    )
    .required(i18n.t('REQUIRED_FIELD_KEY')),
  expire_days: Yup.number()
    .nullable()
    .when('expire_passwords', {
      is: true,
      then: Yup.number()
        .required(i18n.t('REQUIRED_FIELD_KEY'))
        .min(1, i18n.t('MIN_NUMBER_CANNOT_BE_LESS_THAN_ONE_KEY')),
    }),
  zero_trust: Yup.object().shape({
    whitelist_cleanup_interval_days: Yup.number()
      .min(
        1,
        i18n.t('MIN_VALUE_KEY', {
          value: 1,
        })
      )
      .max(
        30,
        i18n.t('MAX_VALUE_KEY', {
          value: 30,
        })
      ),
  }),
});
